import { doOnceDecorator } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackNearbyOffersInfoClick } from './analytics';
import { useGetAboutNearbyHousesData } from './utils/useGetAboutNearbyHousesData';
import { selectActiveTypeFilter } from '../../../selectors/offersHistory';
import { ETypeFilterValues } from '../../../store/offerHistory';
import { NearbyHousesInfo } from '../components';

export const NearbyHousesInfoContainer: React.FC = () => {
  const typeFilterValue = useSelector(selectActiveTypeFilter);
  const { load, data, error, isFetching } = useGetAboutNearbyHousesData();

  const handleLoadData = React.useMemo(
    () =>
      doOnceDecorator(async () => {
        trackNearbyOffersInfoClick();
        await load();
      }),
    [load],
  );

  if (typeFilterValue !== ETypeFilterValues.NearbyHouses) {
    return null;
  }

  return (
    <NearbyHousesInfo
      onMouseEnter={handleLoadData}
      isError={Boolean(error)}
      isLoading={isFetching}
      nearbyHousesInfoData={data}
    />
  );
};
